
import React from "react";

export const Image = ({ title, largeImage, smallImage }) => {
  return (
    <div className="comunhao-item">
      <div className="swiper-image-wrapper">
        <a 
          href={largeImage} 
          title={title} 
          data-lightbox-gallery="gallery1"
          className="swiper-image-link"
          style={{
            display: 'block',
            width: '100%',
            height: '100%'
          }}
        >
          <div className="image-overlay">
            {/* Overlay pode ser adicionado se necessário */}
          </div>
          <img 
            src={smallImage} 
            className="swiper-img" 
            alt={title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center'
            }}
          />
        </a>
      </div>
    </div>
  );
};